import React from "react";
import { Link } from "react-router-dom";

const Error404 = () => {
   return (
      <div className="authincation h-100">
         <div className="container vh-100">
            <div className="row justify-content-center h-100 align-items-center ">
               <div className="col-md-5">
                  <div className="form-input-content text-center error-page">
                     <h1 className="error-text font-weight-bold">404</h1>
                     <h4>
                        <i className="fa fa-exclamation-triangle text-warning" />{" "}
                       No se encontró esta página
                     </h4>
                     <p>
                        Puede que haya escrito mal la dirección o que la página se haya
                        movido.
                     </p>
                     <div>
                        <Link className="btn btn-primary" to="/usuarios">
                           Volver a Usuarios
                        </Link>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default Error404;
